import axiosInstance from '../lib/axios';

export const fetchSubcategories = async ({ categoryId } = {}) => {
    const response = await axiosInstance.get('/admin/subcategories', {
        params: { categoryId },
    });
    return response.data;
};

export const fetchSubcategoryById = async (id) => {
    const response = await axiosInstance.get(`/admin/subcategories/${id}`);
    return response.data;
};

export const createSubcategory = async (subcategoryData) => {
    try {
        const response = await axiosInstance.post('/admin/subcategories', subcategoryData);
        return response.data;
    } catch (error) {
        console.error('Error creating subcategory:', error);
        throw error;
    }
};

export const updateSubcategory = async (id, subcategoryData) => {
    try {
        const response = await axiosInstance.put(`/admin/subcategories/${id}`, subcategoryData);
        return response.data;
    } catch (error) {
        console.error('Error updating subcategory:', error);
        throw error;
    }
};

export const deleteSubcategory = async (id) => {
    try {
        const response = await axiosInstance.delete(`/admin/subcategories/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting subcategory:', error);
        throw error;
    }
};
